import { useQuery } from '@fv/client-core'
import type { VendorSettingsResponse } from '@fv/models'
import type { DTO } from '@fv/models/core'

import { shipperFetch } from '@/utils/shipperFetch'

import { useRole } from '../auth/hooks'

export const vendorSettingsQueryKeys = {
  all: ['all'],
}

export const useVendorSettings = () => {
  const role = useRole()

  return useQuery(
    vendorSettingsQueryKeys.all,
    () => shipperFetch<DTO<VendorSettingsResponse>>(`/vendor/settings`),
    {
      enabled: role === 'vendor',
    },
  )
}
